<div #host class="area-chart-host"></div>
